import { render, staticRenderFns } from "./FullScreen.vue?vue&type=template&id=22a7571e&scoped=true&"
import script from "./FullScreen.vue?vue&type=script&lang=js&"
export * from "./FullScreen.vue?vue&type=script&lang=js&"
import style0 from "./FullScreen.vue?vue&type=style&index=0&id=22a7571e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7571e",
  null
  
)

export default component.exports